import { initAllEdenProductCards } from './eden-card.js?v=20260829-cardfix';

function initCatalogFilters(catalog) {
  const chips = catalog.querySelectorAll('[data-eden-filter]');
  const cards = catalog.querySelectorAll('[data-eden-product-card]');
  const empty = catalog.querySelector('[data-eden-catalog-empty]');

  function applyFilter(filter) {
    let visible = 0;

    cards.forEach((card) => {
      const categories = (card.dataset.categories || 'all').split(',');
      const show = filter === 'all' || categories.includes(filter);
      card.classList.toggle('is-hidden', !show);
      if (show) visible += 1;
    });

    chips.forEach((chip) => {
      chip.classList.toggle('is-active', chip.dataset.edenFilter === filter);
    });

    if (empty) empty.hidden = visible > 0;
  }

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      applyFilter(chip.dataset.edenFilter || 'all');
    });
  });
}

const catalog = document.querySelector('[data-eden-catalog]');
if (catalog) {
  initCatalogFilters(catalog);
  initAllEdenProductCards(catalog);
}
